<template>
  <GwMenu
    :isInside="menuIsInside"
    style="--inside-menu-position: absolute; --inside-menu-min-width: 100%"
    :flOptions="{ strategy: 'absolute' }"
    class="gwsrch flex-1"
    @open="handleSearchInput(), $emit('open', true)"
    @close="$emit('open', false)"
  >
    <template #opener="{ value, methods }">
      <div
        class="gw_input_wrapper gwsrch_input_wrapper flex-1 d-flex"
        style="min-width: clamp(1px, 18rem, 100vw)"
      >
        <input
          ref="searchInput"
          type="text"
          :placeholder="placeholder"
          style="
            --input-height: var(--srch-input-height);
            --input-border-radius: var(--srch-input-radius);
            --input-padding: var(--srch-input-padding);
          "
          :value="inputSearchValue"
          spellcheck="false"
          autocomplete="off"
          @keypress="handleKeyPress"
          @input="
            e => {
              handleSearchInput(e.target.value)
              if (searchResults.length && !value) {
                methods.toggleOpen(true)
              }
            }
          "
        />
        <slot
          name="input_content"
          :methods="methods"
          :value="inputSearchValue"
        ></slot>
        <div
          v-show="inputSearchValue"
          class="mdi mdi-close icon_btn pa-1 right-icon csst csst_nm"
          @click.stop="clearSearch(), methods.toggleOpen(false)"
          @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
        >
          <div
            class="csst_content"
            style="position: fixed"
            v-html="$t('btn.clear')"
          ></div>
        </div>
        <div
          v-if="showChevrons && !inputSearchValue"
          class="right-icon pa-1 mdi cursor-pointer"
          :class="`mdi-chevron-${value ? 'up' : 'down'}`"
          @click="$refs.searchInput.focus()"
        />
      </div>
    </template>
    <template #default="{ methods }">
      <GwBtns2
        v-if="searchResults.length"
        :options="searchResults"
        :arrow-controls="true"
        style="max-height: 24rem"
        :style="contentStyle"
        class="gwbtns_vertical_white gw_menu"
        @click="
          (_e, item) => {
            selectSearch(item), methods.toggleOpen(false)
          }
        "
      >
        <template #default="{ item }">
          <slot
            name="result"
            :item="item"
          >
            {{ item }}
          </slot>
        </template>
      </GwBtns2>
      <div
        v-else-if="inputSearchValue"
        class="clr-grey text-medium pa-2 gw_menu"
      >
        {{ $t('common.no_results') }}
      </div>
    </template>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import GwBtns2 from '@/components/lib/GwBtns2'
import Fuse from 'fuse.js'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'SearchBox',
  components: {
    GwMenu,
    GwBtns2,
  },
  mixins: [float_mix],
  props: {
    items: Array,
    initialValue: String,
    showChevrons: Boolean,
    menuIsInside: {
      type: Boolean,
      default: true,
    },
    contentStyle: String,
    keys: {
      type: Array,
      default: () => [],
      required: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['select', 'open'],
  data() {
    return {
      inputSearchValue: this.initialValue || '',
      searchResults: [],
    }
  },
  methods: {
    handleKeyPress(e) {
      if (e.key === 'Enter') {
        this.selectSearch(this.searchResults[0])
      }
    },
    clearSearch() {
      this.inputSearchValue = ''
      this.$emit('select', null)
    },
    handleSearchInput(str = this.inputSearchValue) {
      const options = {
        keys: ['name', 'coach_name', 'format', ...this.keys],
        threshold: 0.3,
      }
      this.inputSearchValue = str
      this.searchResults = new Fuse(this.items, options)
        .search(this.inputSearchValue)
        .map(result => result.item)
      if (!this.searchResults.length || this.inputSearchValue === this.initialValue) {
        this.searchResults = this.items
      }
      if (!this.inputSearchValue) {
        this.$emit('select', null)
      }
    },
    selectSearch(item) {
      this.inputSearchValue = item.name
      this.$emit('select', item)
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            video_id: item.id,
          },
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped lang="scss">
.gwsrch {
  --srch-input-height: 2.16rem;
  --srch-input-radius: 6px;
  --srch-input-padding: 0.5rem;
  --srch-input-border-color: var(--clr-border);
  --srch-input-border-focus-color: var(--clr-border-focus);
}
.gwsrch_input_wrapper {
  position: relative;
  display: inline-block;
  .right-icon {
    position: absolute;
    right: 0.375rem;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  input {
    border: 1px solid var(--srch-input-border-color);
  }
  input:focus {
    border-color: var(--srch-input-border-focus-color);
  }
}
</style>
